module.exports = __webpack_public_path__ + "static/media/pizza.36f12681.png";